import axios from "axios";
import { useState, useEffect } from "react";
import TabbedHero from "../components/TabbedHero";
import { photosLink, WEB_URL } from "./photosLink";

const DEFAULT_LOGO =
  "https://ftp-endu-net.s3.eu-west-1.amazonaws.com/progetti/ENDUpix/img/event-logo.png";
const PIX_STATUSES = ["ready", "live", "finished"];
const OLD_EDITIONS_MONTHS = 14;
const OLD_EDITIONS_LIMIT = 2;

const dummyEvent = {
  beginDate: "2021-01-01T04:00:00Z",
  name: null,
  city: null,
  province: "ND",
  link: "http://www.endupix.net",
  logoLink: DEFAULT_LOGO,
  oldEventList: [],
};

const dummyEventList = [dummyEvent, dummyEvent, dummyEvent];

const formatDay = (offsetDays) => {
  const day = new Date();
  day.setDate(day.getDate() + offsetDays);
  const pad = (n) => String(n).padStart(2, "0");
  return `${day.getFullYear()}-${pad(day.getMonth() + 1)}-${pad(day.getDate())}`;
};

const TAB_FILTERS = {
  past: () => ({ dateTo: formatDay(0), sort: "-date.from" }),
  next: () => ({ dateFrom: formatDay(1), sort: "date.from" }),
};

const hasPixService = (edition) =>
  (edition.services ?? []).some(
    (service) =>
      service.name === "endupix" && PIX_STATUSES.includes(service.status)
  );

const previousPixEditions = (event) => {
  const cutoff = new Date();
  cutoff.setMonth(cutoff.getMonth() - OLD_EDITIONS_MONTHS);

  return (event.editions ?? [])
    .filter(
      (edition) =>
        edition.id !== event.id &&
        edition.date?.from < event.date.from &&
        new Date(edition.date.from) > cutoff &&
        hasPixService(edition)
    )
    .sort((a, b) => b.date.from.localeCompare(a.date.from))
    .slice(0, OLD_EDITIONS_LIMIT)
    .map((edition) => ({
      id: edition.id,
      year: new Date(edition.date.from).getFullYear(),
      link: photosLink(event.slug, edition.id),
    }));
};

const toPixEvent = (event, tab) => ({
  id: event.id,
  slug: event.slug,
  name: event.name,
  beginDate: event.date.from,
  endDate: event.date.to,
  city: event.location?.city,
  province: event.location?.district,
  logoLink: event.logo || DEFAULT_LOGO,
  disciplineId: event.discipline?.id,
  link:
    tab === "next"
      ? `${WEB_URL}/events/${event.slug}`
      : photosLink(event.slug, event.id),
  oldEventList: previousPixEditions(event),
  time: tab,
});

function sleep(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

const PixEventList = () => {
  // type: last or next
  const [tabShown, setTabShown] = useState("past");
  const [numberOfEventsShown, setNumberOfEventsShown] = useState(12);
  const [eventsShown, setEventsShown] = useState(dummyEventList);
  const [totalNumberOfEvents, setTotalNumberOfEvents] = useState(0);

  const setActiveTab = (active) => {
    setTabShown(active);
    setNumberOfEventsShown(12);
  };

  useEffect(() => {
    const loadPageData = async () => {
      try {
        const { data } = await axios.get(
          `${window._env_.REACT_PUBLIC_ENDPOINT}/events`,
          {
            params: {
              "services.name": "endupix",
              "services.status": PIX_STATUSES.join(","),
              pageSize: numberOfEventsShown,
              includeEditions: true,
              ...TAB_FILTERS[tabShown](),
            },
          }
        );
        setEventsShown(data.items.map((event) => toPixEvent(event, tabShown)));
        setTotalNumberOfEvents(data.totalItems);
        const url = window.location.href;
        if (url.includes("#collaboration")) {
          sleep(700).then(() => {
            console.log(url);
            window.location.href = url;
          });
        }
      } catch (error) {
        console.error(error);
      }
    };
    loadPageData();
  }, [tabShown, numberOfEventsShown]);

  const bumpNumberOfEvents = () => {
    setNumberOfEventsShown(numberOfEventsShown + 6);
  };

  return (
    <TabbedHero
      activeTab={tabShown}
      setActiveTab={setActiveTab}
      eventList={eventsShown}
      showLoadMore={
        numberOfEventsShown < 30 && numberOfEventsShown < totalNumberOfEvents
      }
      bumpNumberOfEvents={bumpNumberOfEvents}
    />
  );
};

export default PixEventList;
